import { View } from './view'

export const Geo = View
